<template>
  <div class="">
    <h1>Access Denied</h1>
  </div>
</template>


<script>
</script>